export const serviceOptions = [
  'attachable',
  'bookable',
  'brochure',
  'categorizable',
  'deliverable',
  'designable',
  'digital',
  'editorial',
  'hidden',
  'imageable',
  'multi_provider',
  'notable',
  'proposal',
  'publication',
  'quote',
  'searchable',
  'shippable',
  'social_media',
  'taskable',
  'templatable',
  'video',
]

export default serviceOptions
